module.exports = __webpack_public_path__ + "img/13.fec9abb8.webp";